import React, { useMemo, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import GoalVideoComponent from "./GoalVideoComponent";
import Podium from "./Podium";

const Leaderboard = ({ goals, setTournamentData }) => {
  const sortedGoals = useMemo(() => {
    return [...(goals || [])].sort((a, b) => b.voteCount - a.voteCount);
  }, [goals]);

  const topThree = sortedGoals.slice(0, 3);

  return (
    <Box
      sx={{ borderTop: "1px solid #414466" }}
      className="leaderboard-data-wrapper"
    >
      <Podium goals={topThree} />

      <Box sx={{ px: { xs: 2, md: 4 } }}>
        <Typography sx={{ color: "#fff", fontSize: "22px", mb: 2 }}>
          Rank
        </Typography>

        {sortedGoals.length > 0 ? (
          sortedGoals.map((goal, index) => (
            <GoalVideoComponent
              key={goal.id}
              data={goal}
              rank={index + 1}
              index={index}
              setTournamentData={setTournamentData}
            />
          ))
        ) : (
          <Box className="no-data-found">No Data Found</Box>
        )}
      </Box>
    </Box>
  );
};

export default Leaderboard;